module.exports = __webpack_public_path__ + "media/images/icon_list/notification_filled-e22f4e572695d3146868e01125d62c8c.svg";